import * as React from 'react';

import { ErrorStateType } from '@models';
import { RequestError, HttpStatusCode } from '@utils';

import {
  ICreateUser,
  CREATE_USER_FAILED,
  CreateUserActionTypes,
  CREATED_USER,
  CREATING_USER,
} from '@store/types';

import { create as createRequest } from '@services/user';

import LocaleLinks from '../../../components/locale/LocaleLinks';

export const create = (content: ICreateUser): any => {
  return (dispatch: (state: any) => void) => {
    dispatch(creatingAccount());
    return createRequest(content)
      .then(() => {
        dispatch(createdAccount());
      })
      .catch((error: RequestError) => {
        let message: JSX.Element = (
          <React.Fragment>{error.message}</React.Fragment>
        );
        if (error.status === HttpStatusCode.UNPROCESSABLE_ENTITY) {
          switch (error.code) {
            case ErrorStateType.UserAlreadyExists:
              message = (
                <LocaleLinks
                  localeKey='createUser_error_userAlreadyExists'
                  links={[{ name: 'login', route: '/' }]}
                />
              );
              break;
          }
        }
        dispatch(createAccountFailed(message));
      });
  };
};

export const createAccountFailed = (
  error: JSX.Element
): CreateUserActionTypes => ({
  type: CREATE_USER_FAILED,
  payload: error,
});

export const createdAccount = (): CreateUserActionTypes => ({
  type: CREATED_USER,
  payload: undefined,
});

export const creatingAccount = (): CreateUserActionTypes => ({
  type: CREATING_USER,
  payload: undefined,
});
